import { Dayjs } from 'dayjs'
import { useI18n } from 'vue-i18n'

import {
  getDateTimeString,
  getNow,
  getTransformedDate,
} from '@shared/utils/helpers/date-formatter'

export const useMessageDate = () => {
  const { t } = useI18n()

  const isDifferentDay = (
    messageIndex: number,
    allMessages: Array<{ createdAt: string | Date | Dayjs }>
  ) => {
    const isFirstMessage = messageIndex === 0

    if (isFirstMessage) {
      return true
    }

    if (!allMessages[messageIndex - 1] || !allMessages[messageIndex]) {
      return false
    }

    const previousDay = getTransformedDate(
      allMessages[messageIndex - 1]?.createdAt
    )

    const currentDay = getTransformedDate(allMessages[messageIndex]?.createdAt)

    return !currentDay.isSame(previousDay, 'day')
  }

  const getMessageDate = (
    messageIndex: number,
    allMessages: Array<{ createdAt: string | Date | Dayjs }>
  ) => {
    const messageDate = getTransformedDate(allMessages[messageIndex]?.createdAt)

    const dateToday = getNow()

    if (messageDate.isSame(dateToday, 'day')) {
      return t('timeUnits.today')
    } else if (messageDate.isYesterday()) {
      return t('timeUnits.yesterday')
    } else {
      const isCurrentYear = messageDate.isSame(dateToday, 'year')
      const formatPattern = isCurrentYear ? 'ddd DD MMM' : 'ddd DD MMM YYYY'
      return getDateTimeString({
        date: allMessages[messageIndex].createdAt,
        formatPattern,
        fallbackValue: '',
      })
    }
  }

  return {
    getMessageDate,
    isDifferentDay,
  }
}
